export default "__VITE_ASSET__cfb13ab2__"